
import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { ROUTES } from "const";
import { MASTERS } from "./master-data";
import masterDetails from "./master-details.json";
import "./MasterMedicinaDetail.css";
import { FormMasterUnicamillus } from "../adesioni";

const SECTIONS = [
    { id: "presentazione", title: "Presentazione", content: "presentation" },
    { id: "obiettivi-formativi", title: "Obiettivi formativi", content: "objectives" },
    { id: "ambito-disciplinare", title: "Ambito disciplinare", content: "disciplinaryAreas" },
    { id: "modalita-di-svolgimento", title: "Modalità di svolgimento", content: "delivery" },
    { id: "sede-esame-finale", title: "Sede d’esame finale", content: "examLocations" },
    { id: "richiesta-informazioni", title: "Richiesta informazioni", content: "informationRequest" },
];

const normalizeSlug = (slug = "") => slug.replace(/^\/+|\/+$/g, "");

class MasterMedicinaDetail extends Component {
    tabRefs = [];

    selectSection = (id) => {
        const { history, location } = this.props;
        history.replace({
            pathname: location.pathname,
            search: location.search,
            hash: `#${id}`,
        });
    };

    handleTabKeyDown = (event, index) => {
        const directions = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 };
        let nextIndex;

        if (event.key === "Home") nextIndex = 0;
        else if (event.key === "End") nextIndex = SECTIONS.length - 1;
        else if (directions[event.key]) nextIndex = (index + directions[event.key] + SECTIONS.length) % SECTIONS.length;
        else return;

        event.preventDefault();
        this.selectSection(SECTIONS[nextIndex].id);
        this.tabRefs[nextIndex].focus();
    };

    renderBlocks(blocks) {
        return blocks.map((block, index) => {
            if (block.type === "heading") return <h3 key={index}>{block.text}</h3>;
            if (block.type === "list") {
                return (
                    <ul key={index}>
                        {block.items.map((item) => <li key={item}>{item}</li>)}
                    </ul>
                );
            }
            return <p key={index}>{block.text}</p>;
        });
    }

    renderNotFound() {
        return (
            <section className="master-medicina-detail master-medicina-detail--not-found">
                <Helmet>
                    <title>Master non trovato | Mnemosine</title>
                    <meta name="robots" content="noindex" />
                </Helmet>
                <div className="master-medicina-detail__container">
                    <h1>Master non trovato</h1>
                    <p>Il master richiesto non è disponibile. Consulta l’elenco per scegliere un percorso formativo.</p>
                    <Link to={ROUTES.MASTER_MEDICINA_LIST}>Torna ai Master Universitari Area Medica</Link>
                </div>
            </section>
        );
    }

    render() {
        const { slug } = this.props.match.params;
        const master = MASTERS.find((item) => normalizeSlug(item.slug) === normalizeSlug(slug));
        const details = master && masterDetails.masters[master.code];
        if (!details) return this.renderNotFound();

        const activeSection = SECTIONS.find((section) => this.props.location.hash === `#${section.id}`) || SECTIONS[0];
        const pageTitle = `${master.title} [COD. ${master.code}]`;
        const description = details.presentation[0].text;

        return (
            <article className="master-medicina-detail">
                <Helmet>
                    <title>{pageTitle} | Mnemosine</title>
                    <meta name="description" content={description} />
                    <meta property="og:title" content={pageTitle} />
                    <meta property="og:description" content={description} />
                    <meta property="og:image" content={`/img/master-medicina/${master.image}`} />
                </Helmet>                

                <header className="master-medicina-detail__hero">
                    <img className="master-medicina-detail__image" src={`/img/master-medicina/${master.image}`} alt="" />
                    <div className="master-medicina-detail__container master-medicina-detail__hero-content">
                        <p className="master-medicina-detail__label">{master.label}</p>
                        <h1>{pageTitle}</h1>
                    </div>
                </header>

                <div className="master-medicina-detail__container">
                    <dl className="master-medicina-detail__facts" aria-label="Informazioni sul master">
                        <div><dt>Modalità</dt><dd>Online</dd></div>
                        <div><dt>Durata</dt><dd>{master.duration}</dd></div>
                        <div><dt>Crediti</dt><dd>60 CFU</dd></div>
                        <div><dt>Lingua</dt><dd>Italiano</dd></div>
                    </dl>

                    <div className="master-medicina-detail__layout">
                        <aside className="master-medicina-detail__sidebar">
                            <nav aria-label="Sezioni del master">
                                <div className="master-medicina-detail__tabs" role="tablist" aria-label="Informazioni sul percorso" aria-orientation="vertical">
                                    {SECTIONS.map((section, index) => (
                                        <button
                                            className="master-medicina-detail__tab"
                                            key={section.id}
                                            type="button"
                                            id={`tab-${section.id}`}
                                            role="tab"
                                            aria-controls={section.id}
                                            aria-selected={activeSection.id === section.id}
                                            tabIndex={activeSection.id === section.id ? 0 : -1}
                                            onClick={() => this.selectSection(section.id)}
                                            onKeyDown={(event) => this.handleTabKeyDown(event, index)}
                                            ref={(element) => { this.tabRefs[index] = element; }}
                                        >
                                            {section.title}
                                        </button>
                                    ))}
                                </div>
                            </nav>
                        </aside>

                        <div className="master-medicina-detail__content">
                            {SECTIONS.map((section) => (
                                <section
                                    className="master-medicina-detail__panel"
                                    key={section.id}
                                    id={section.id}
                                    role="tabpanel"
                                    aria-labelledby={`tab-${section.id}`}
                                    tabIndex="0"
                                    hidden={activeSection.id !== section.id}
                                >
                                    <h2>{section.title}</h2>
                                    {section.content === "informationRequest" ? (
                                        <FormMasterUnicamillus key={master.code} masterCode={master.code} />
                                    ) : section.content === "examLocations" ? (
                                        <ul className="master-medicina-detail__locations">
                                            {masterDetails.examLocations.map((city) => <li key={city}>{city}</li>)}
                                        </ul>
                                    ) : this.renderBlocks(section.content === "delivery" ? masterDetails.delivery : details[section.content])}
                                </section>
                            ))}
                        </div>
                        
                    </div>
                </div>
            </article>
        );
    }
}

export default withRouter(MasterMedicinaDetail);
